import React, { useState, useContext, useEffect, useMemo } from "react";
import { Link, useLocation } from "react-router-dom";
import Axe from "../../../assets/images/x.svg";
import ic_upload_dark from "../../../assets/images/ic_upload_dark.svg";

import down_arrow from "../../../assets/images/down_arrow.svg";
import ic_color from "../../../assets/images/ic_color.svg";
import ic_export from "../../../assets/images/ic_export.svg";
import ic_printer from "../../../assets/images/ic_printer.svg";
import ic_upload from "../../../assets/images/ic_upload.svg";
import ic_view from "../../../assets/images/ic_view.svg";
import image_prf from "../../../assets/images/image_prf.svg";
import ic_search from "../../../assets/images/ic_search.svg";
import ic_bars_dot from "../../../assets/images/ic_bars_dot.svg";
import ic_search_dark from "../../../assets/images/ic_search_dark.svg";
import ic_bars_dot_dark from "../../../assets/images/ic_bars_dot_dark.svg";
import Logo from "../../../assets/images/custom-rb-logo.png";
import ic_blue_pen from "../../../assets/images/ic_green_pen.svg";
import Dropdown from "react-bootstrap/Dropdown";
import Up_arrow_white from "../../../assets/images/Up_arrow_white.svg";
import { Modal } from "react-bootstrap";
import { AppContext } from "../../../context/AppContext";
import close_modal from "../../../assets/images/close_modal.svg";
import close_modal_dark from "../../../assets/images/close_modal_dark.svg";
import Tab from "react-bootstrap/Tab";
import Nav from "react-bootstrap/Nav";
import ApiConfig from "../../../api/ApiConfig";
import {
  PostCallWithAuthToken,
  PostCallWithErrorResponse,
  simpleGetCall,
  simpleGetCallWithToken,
} from "../../../api/ApiServices";
import { PDFExport, savePDF } from "@progress/kendo-react-pdf";
import { exportComponentAsJPEG } from "react-component-export-image";
import Moment from "react-moment";
import { ToWords } from "to-words";
import { useReactToPrint } from "react-to-print";
import Loader from "../../Loader";
import { debounce } from "lodash";
import PurchaseServiceForm from "./PurchaseServiceForm";

import BootstrapSpinner from "../../../sharedComponent/BootstrapSpinner";
import { displayDateFormat } from "../../../common";
import { ToastMsg } from "../../TostMsg";

let PurchaseServices = () => {
  // GETTING PURCHASE SERVICE INVOICE DATA
  const location = useLocation();
  const invoiceEditData = location?.state?.invoiceData;
  const action = location?.state?.action;
  const [invoiceAction, setInvoiceAction] = useState(action);
  // GETTING PURCHASE SERVICE INVOICE DATA

  const {
    sidebar,
    hideCopy,
    setHideCopy,
    backdrop,
    setbackdrop,
    Dark,
    units,
    setSidebar,
    setProductNameWidth,
    hideBothSide,
    setHideBothSide,
  } = useContext(AppContext);

  const appSettings = JSON.parse(localStorage.getItem("appSettings"))
    ? JSON.parse(localStorage.getItem("appSettings"))
    : {};

  const container = React.useRef(null);
  const pdfExportComponent = React.useRef(null);
  const toWords = new ToWords();
  const exportPDFWithComponent = () => {
    if (pdfExportComponent.current) {
      pdfExportComponent.current.save();
    }
  };

  const [discountVal, setDiscountVal] = useState(JSON.parse(localStorage.getItem("appSettings")) || {});
  useEffect(() => {
    const storedValue = JSON.parse(localStorage.getItem("appSettings"));
    if (storedValue) {
      setDiscountVal(storedValue);
    }
  }, []);

  const [printButton, setPrintButton] = useState(true);
  const [printModal, setPrintModal] = useState(false);
  const [pdfCheck, setpdfCheck] = useState(false);
  var commaNumber = require("comma-number");

  let [loading, setLoading] = useState(false);
  const [invoiceNo, setInvoiceNo] = useState("");
  const [jpegCheck, setJpegCheck] = useState(false);
  const handlePrint = useReactToPrint({
    contentRef: container
  });
  const [newInvoice, setNewInvoice] = useState(0);

  const [states, setStates] = useState([]);
  const [previewTaxInvoiceData, setPreviewTaxInvoiceData] = useState({});
  const [CopypreviewTaxInvoiceData, setCopyPreviewTaxInvoiceData] = useState([
    {},
  ]);
  const [typeOfPrint, setTypeOfPrint] = useState([]);
  const [previewLoader, setPreviewLoader] = useState(false);
  const [selectedInvoiceId, setSelectedInvoiceId] = useState();

  // View, Print and Export Options
  const printAction = () => {
    ToastMsg("error", "Please submit the form first");
  };

  // RecievedInvoiceIdFromChild
  const reciveInvoiceId = (id) => {
    setSelectedInvoiceId(id);
  };

  // Get Invoice Tax Data Api se
  const getTaxInvoiceDataForPreview = () => {
    // 3022
    simpleGetCallWithToken(
      ApiConfig.GET_PURCHASE_INVOICE_TAX_DATA + `/${selectedInvoiceId}`
    )
      .then((res) => {
        setPreviewTaxInvoiceData(res.data);
      })
      .catch((err) => console.log(err));
  };

  // Get Invoice Tax Data Api se
  const getTaxInvoiceData = (invId) => {
    setPreviewLoader(true);
    simpleGetCallWithToken(
      ApiConfig.GET_PURCHASE_INVOICE_TAX_DATA + `/${invId}`
    )
      .then((res) => {
        if (res.success === true) {
          if (res.data !== null) {
            setPreviewLoader(false);
            setPreviewTaxInvoiceData(res.data);
          } else {
            setPreviewLoader(true);
            console.log("Error response", res);
          }
        } else {
          setPreviewLoader(true);
          console.log("Error response", res);
        }
      })
      .catch((err) => console.log(err));
  };

  const getCopyTaxInvoiceData = (id) => {
    simpleGetCallWithToken(ApiConfig.GET_PURCHASE_INVOICE_TAX_DATA + `/${id}`)
      .then((res) => {
        setCopyPreviewTaxInvoiceData(res.data);
        setInvoiceAction("submitInvoice");
      })
      .catch((err) => console.log(err));
  };

  let [isView, setIsView] = useState(false);

  const [profile, setprofile] = useState(false);
  const [Print, setPrint] = useState(false);

  const [invoiceListData, setInvoiceListData] = useState([]);
  const [upperCaseGstNumber, setUpperCaseGstNumber] = useState("");

  const handleInvoiceSearch = debounce((e) => {
    getInvoiceDetailsList(e.target.value);
  }, 1000);

  // Get Customer Invoices for search results
  const getInvoiceDetailsList = (gstNo) => {
    setLoading(true);
    simpleGetCallWithToken(
      ApiConfig.SEARCH_PURCHASE_INVOICES + `?searchtxt=${gstNo}&invoicetype=Purchase - Service`
    )
      .then((res) => {
        setInvoiceListData(res.data.reverse());
        setLoading(false);
      })
      .catch((err) => {
        if (err) {
          setLoading(false);
          setInvoiceListData([]);
        }
        console.log(err);
      });
  };

  useEffect(() => {
    getInvoiceDetailsList("");
  }, []);

  const handlePreviewFormat = () => {
    if (selectedInvoiceId) {
      getTaxInvoiceData();
      setIsView(true);
    }
  };

  const getPageMargins = () => {
    return `@page { margin: ${"20px"} ${"20px"} ${"20px"} ${"20px"} !important; } 
    @media print {
      .page-break {
        display: block;
        page-break-after: always;
      }
    }
    } `;
  };

  const amountInWords = toWords.convert(
    previewTaxInvoiceData.totalAmount ? previewTaxInvoiceData.totalAmount : 0,
    {
      currency: true,
    }
  );

  const isStateSame =
    previewTaxInvoiceData?.compGstNo?.substring(0, 2) ===
      previewTaxInvoiceData?.placeOfSupply?.split("-")[1]
      ? true
      : previewTaxInvoiceData?.placeOfSupply === ""
        ? true
        : false;

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.ctrlKey && event.altKey && event.key === "h") {
        setHideBothSide({
          lg: "12",
          displayBlock: "none",
        });
        setProductNameWidth(true);
        setSidebar(false);
      } else if (event.ctrlKey && event.altKey && event.key === "s") {
        setHideBothSide({
          lg: "8",
          displayBlock: "",
        });
        setProductNameWidth(false);
        setSidebar(true);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const isChequePayment = previewTaxInvoiceData.modeOfPay === "Cheque";

  return (
    <>
      <main
        className={
          sidebar ? "SalesGoods-main" : "cx-active SalesGoods-main"
        }
        id="cx-main"
      >
        <div id="purchase-main">
          <section className="cx-inneer-header">
            <div className="main-inner">
              <div className="left">
                <label htmlFor="">
                  Services Invoice
                  {/* <img src={down_arrow} alt="" /> */}
                </label>
              </div>
              <div className="right">
                <Link to="#">
                  <button
                    onClick={() => {
                      setNewInvoice(newInvoice + 1);
                      setInvoiceAction("submitInvoice");
                    }}
                  >
                    Clear Invoice
                  </button>
                </Link>
              </div>
            </div>
          </section>
          <section className="cx-content-section">
            <div className="row main-row">
              {/* ================ LEFT SECTION ============= */}

              <div className={`col-lg-${hideBothSide?.lg} left-section my-2`}>
                <div className="left-top-heder-main">
                  <div className="left">
                    <label htmlFor="" className="porfileLabel">
                      INVOICE : <span>{invoiceNo}</span>
                    </label>
                  </div>
                  <div className="right icons">
                    <div className="d-flex align-items-center">
                      {/* {selectedInvoiceId ? (
                        <Link
                          to="#"
                          className="header-green-icons"
                          onClick={() => {
                            setPrint(!Print);
                            getTaxInvoiceData();
                          }}
                        >
                          <img src={ic_printer} alt="" />
                        </Link>
                      ) : (
                        <Link
                          to="#"
                          onClick={printAction}
                          className="header-green-icons"
                        >
                          <img src={ic_printer} alt="" />
                        </Link>
                      )} */}

                      <Modal
                        show={Print}
                        onHide={() => setPrint(false)}
                        centered
                        className="print-modal-box-main"
                        id="print-modal-blue"
                      >
                        <Modal.Body>
                          <div className="header-print" closeButton>
                            <div className="left">
                              <label htmlFor="">Print</label>
                            </div>
                            <div className="right">
                              {Dark === "lightMode" ? (
                                <img
                                  src={close_modal}
                                  alt=""
                                  onClick={() => setPrint(false)}
                                  style={{ cursor: "pointer" }}
                                />
                              ) : (
                                <img
                                  src={close_modal_dark}
                                  alt=""
                                  onClick={() => setPrint(false)}
                                  style={{ cursor: "pointer" }}
                                />
                              )}
                            </div>
                          </div>
                          <div className="">
                            <div className="option-btns">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                name="flexRadioDefault"
                                id="flexRadioDefault11"
                                checked={
                                  typeOfPrint.length === 3 ? true : false
                                }
                                onChange={(e) =>
                                  e.target.checked
                                    ? setTypeOfPrint([
                                      "Orginal for Buyer",
                                      "Duplicate for Transporter",
                                      "Triplicate for Supplier",
                                    ])
                                    : setTypeOfPrint([])
                                }
                              />

                              <label
                                className="form-check-label"
                                for="flexRadioDefault11"
                              >
                                All
                              </label>
                            </div>
                            <div className="option-btns">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                name="flexRadioDefault"
                                id="flexRadioDefault22"
                                checked={
                                  typeOfPrint.includes("Orginal for Buyer")
                                    ? true
                                    : false
                                }
                                onChange={(e) => {
                                  e.target.checked
                                    ? setTypeOfPrint([
                                      ...typeOfPrint,
                                      "Orginal for Buyer",
                                    ])
                                    : setTypeOfPrint(
                                      typeOfPrint.filter(
                                        (type) => type != "Orginal for Buyer"
                                      )
                                    );
                                }}
                              />

                              <label
                                className="form-check-label"
                                for="flexRadioDefault22"
                              >
                                Orginal for Buyer
                              </label>
                            </div>
                            <div className="option-btns">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                name="flexRadioDefault"
                                id="flexRadioDefault33"
                                checked={
                                  typeOfPrint.includes(
                                    "Duplicate for Transporter"
                                  )
                                    ? true
                                    : false
                                }
                                onChange={(e) => {
                                  e.target.checked
                                    ? setTypeOfPrint([
                                      ...typeOfPrint,
                                      "Duplicate for Transporter",
                                    ])
                                    : setTypeOfPrint(
                                      typeOfPrint.filter(
                                        (type) =>
                                          type != "Duplicate for Transporter"
                                      )
                                    );
                                }}
                              />

                              <label
                                className="form-check-label"
                                for="flexRadioDefault33"
                              >
                                Duplicate for Transporter
                              </label>
                            </div>
                            <div className="option-btns">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                name="flexRadioDefault"
                                id="flexRadioDefault44"
                                checked={
                                  typeOfPrint.includes(
                                    "Triplicate for Supplier"
                                  )
                                    ? true
                                    : false
                                }
                                onChange={(e) => {
                                  e.target.checked
                                    ? setTypeOfPrint([
                                      ...typeOfPrint,
                                      "Triplicate for Supplier",
                                    ])
                                    : setTypeOfPrint(
                                      typeOfPrint.filter(
                                        (type) =>
                                          type != "Triplicate for Supplier"
                                      )
                                    );
                                }}
                              />

                              <label
                                className="form-check-label"
                                for="flexRadioDefault44"
                              >
                                Triplicate for Supplier
                              </label>
                            </div>
                          </div>
                          <div className="footer-print">
                            <Link
                              to="#"
                              className="cancelbtn text-center"
                              // onClick={() => setPrint(false)}
                              onClick={() => {
                                setPrint(false);
                                setTypeOfPrint([]);
                              }}
                            >
                              Cancel
                            </Link>
                            <Link
                              to="#"
                              className="savebtn text-center"
                              // onClick={() => {
                              //   setPrint(false);
                              //   setPrintModal(true);
                              //   getTaxInvoiceData();
                              // }}
                              onClick={() => {
                                if (typeOfPrint.length === 0) {
                                  ToastMsg("error", "Please select type of print");
                                } else {
                                  setPrintModal(true);
                                  // getTaxInvoiceData();
                                }
                              }}
                            >
                              Print
                            </Link>
                          </div>
                        </Modal.Body>
                      </Modal>

                      {/* {selectedInvoiceId ? (
                        <Link
                          to="#"
                          className="header-green-icons"
                          onClick={() => {
                            setHideCopy(true);
                            setJpegCheck(false);
                            setpdfCheck(false);
                            getTaxInvoiceDataForPreview();
                            getTaxInvoiceData();
                            setIsView(true);
                            setPrintButton(false)
                          }}
                        >
                          <img src={ic_view} alt="" />
                        </Link>
                      ) : (
                        <Link
                          to="#"
                          onClick={printAction}
                          className="header-green-icons"
                        >
                          <img src={ic_view} alt="" />
                        </Link>
                      )} */}

                      {/* <Dropdown className="header-dropdown-main">
                        {selectedInvoiceId ? (
                          <Dropdown.Toggle
                            id="dropdown-basic"
                            className="toggleBtn"
                          >
                            <Link to="#" className="header-green-icons">
                              <img src={ic_export} alt="" />
                            </Link>
                          </Dropdown.Toggle>
                        ) : (
                          <Dropdown.Toggle
                            id="dropdown-basic"
                            className="toggleBtn"
                            onClick={printAction}
                          >
                            <Link to="#" className="header-green-icons">
                              <img src={ic_export} alt="" />
                            </Link>
                          </Dropdown.Toggle>
                        )}
                        {selectedInvoiceId ? (
                          <Dropdown.Menu
                            id="dorp-shadow"
                            className="insetlocation"
                          >
                            <img
                              src={Up_arrow_white}
                              alt=""
                              className="up-img"
                            />
                            <div className="heading">
                              <label htmlFor="">Export As</label>
                            </div>

                            <div className="option-btns">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="flexRadioDefault"
                                id="flexRadioDefault1"
                                onChange={(e) => {
                                  setpdfCheck({ pdfCheck: e.target.checked });
                                  handlePreviewFormat();
                                  setJpegCheck(false);
                                  setHideCopy(true);
                                  setPrintButton(false)
                                }}
                              />

                              <label
                                className="form-check-label"
                                for="flexRadioDefault1"
                              >
                                PDF
                              </label>
                            </div>
                            <div className="option-btns">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="flexRadioDefault"
                                id="flexRadioDefault2"
                              />

                              <label
                                className="form-check-label"
                                for="flexRadioDefault2"
                              >
                                Word
                              </label>
                            </div>
                            <div className="option-btns">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="flexRadioDefault"
                                id="flexRadioDefault3"
                                onChange={(e) => {
                                  setJpegCheck({ jpegCheck: e.target.checked });
                                  handlePreviewFormat();
                                  setpdfCheck(false);
                                  setHideCopy(true);
                                  setPrintButton(false)
                                }}
                              />

                              <label
                                className="form-check-label"
                                for="flexRadioDefault3"
                              >
                                JPEG
                              </label>
                            </div>
                          </Dropdown.Menu>
                        ) : (
                          ""
                        )}
                      </Dropdown>
                      <div className="seprator-line"></div> */}

                      <Dropdown
                        className="header-dropdown-main"
                        id="profile-dropdown-main"
                      >
                        <div
                          onClick={() => {
                            setbackdrop(!backdrop);
                            setprofile(!profile);
                          }}
                        >
                          <Dropdown.Toggle id="dropdown-basic">
                            <Link to="#" className="img-profile">
                              <img
                                src={image_prf}
                                alt=""
                                className={profile ? "Zindex2100" : ""}
                              />
                            </Link>
                          </Dropdown.Toggle>
                        </div>

                        <Dropdown.Menu>
                          <div className="outer-border">
                            <img
                              src={Up_arrow_white}
                              alt=""
                              className="up-img"
                            />
                            <div className="main-profile-info">
                              <div className="row prosnal-info">
                                <div className="left col-lg-7">
                                  <div className="name">
                                    <div className="key">
                                      <label htmlFor="">Name</label>
                                    </div>
                                    <div className="value">
                                      <label htmlFor="">Robert Doe</label>
                                    </div>
                                  </div>
                                  <div className="business">
                                    <div className="key">
                                      <label htmlFor="">
                                        Company/Business Name
                                      </label>
                                    </div>
                                    <div className="value">
                                      <label htmlFor="">
                                        Redbytes Software Pvt. Ltd.
                                      </label>
                                    </div>
                                  </div>
                                  <div className="gst-no">
                                    <div className="key">
                                      <label htmlFor="">GST NO.</label>
                                    </div>
                                    <div className="value">
                                      <label htmlFor="">27ABCDEFGHI9A</label>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-5 right">
                                  <div className="name">
                                    <div className="key">
                                      <label htmlFor="">Taxpayer Type</label>
                                    </div>
                                    <div className="value">
                                      <label htmlFor="">Regular</label>
                                    </div>
                                  </div>
                                  <div className="business">
                                    <div className="key">
                                      <label htmlFor="">
                                        Constitution of Business
                                      </label>
                                    </div>
                                    <div className="value">
                                      <label htmlFor="">Private Limited</label>
                                    </div>
                                  </div>
                                  <div className="gst-no">
                                    <div className="key">
                                      <label htmlFor="">GSTIN Status</label>
                                    </div>
                                    <div className="value">
                                      <label htmlFor="">Active</label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="table-details">
                                <div className="heading">
                                  <label htmlFor="">Details</label>
                                </div>
                                <div className="table-main">
                                  <table>
                                    <tr>
                                      <td className="center-data">Sr.No</td>
                                      <td>Particular</td>
                                      <td className="center-data">
                                        HSN/SAC Code
                                      </td>
                                    </tr>
                                    <tr>
                                      <td className="center-data">1</td>
                                      <td>Accounting and Bookeeping Service</td>
                                      <td className="center-data">998822</td>
                                    </tr>
                                    <tr>
                                      <td className="center-data">2</td>
                                      <td>IT and Web Development Service</td>
                                      <td className="center-data">223355</td>
                                    </tr>
                                    <tr>
                                      <td className="center-data">3</td>
                                      <td>Car Loans and Bike Loan Service</td>
                                      <td className="center-data">564790</td>
                                    </tr>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </div>
                </div>

                <PurchaseServiceForm
                  states={states}
                  newInvoice={newInvoice}
                  reciveInvoiceId={reciveInvoiceId}
                  CopiedData={CopypreviewTaxInvoiceData}
                  setInvoiceNo={setInvoiceNo}
                  invoiceNo={invoiceNo}
                  handleInvoiceSearch={handleInvoiceSearch}
                  getTaxInvoiceData={getTaxInvoiceData}
                  setIsView={setIsView}
                  setPrintButton={setPrintButton}
                  getInvoiceDetailsList={getInvoiceDetailsList}
                  appSettings={appSettings}
                  invoiceEditData={invoiceEditData}
                  invoiceAction={invoiceAction}
                  setInvoiceAction={setInvoiceAction}
                // setHideBothSide={setHideBothSide}
                />

                {/* Preview Modal, PreviewModal */}
                {/* =================== PREVIEW MODAL END ======================== */}
                <Modal
                  style={{ zIndex: "2200" }}
                  className="purchase-view-modal"
                  size="lg"
                  show={isView}
                  onHide={() => setIsView(false)}
                  aria-labelledby="example-modal-sizes-title-lg"
                >
                  <Modal.Body>
                    <div className="btnCloseRper">
                      <div>
                        <Link
                          to="#"
                          className="text-white"
                          onClick={() => {
                            setIsView(false);
                            setHideCopy(false);
                            setJpegCheck(false);
                            setpdfCheck(false);
                            setPrintButton(false);
                          }}
                        >
                          {Dark === "lightMode" ? (
                            <img
                              src={close_modal}
                              alt=""
                              onClick={() => setPrint(false)}
                              style={{ cursor: "pointer" }}
                            />
                          ) : (
                            <img
                              src={close_modal_dark}
                              alt=""
                              onClick={() => setPrint(false)}
                              style={{ cursor: "pointer" }}
                            />
                          )}
                        </Link>
                      </div>
                      <div style={{ display: "flex" }}>
                        {printButton && (
                          <div style={{ marginRight: "15px" }}>
                            <Link
                              className="salesCopyBtn text-white rpsCopyBtn"
                              onClick={() => {
                                setPrint(true);
                                // getTaxInvoiceData();
                                setIsView(false);
                              }}
                            >
                              Print
                            </Link>
                          </div>
                        )}

                        {hideCopy == false ? (
                          <div>
                            <Link
                              to="#"
                              className="salesCopyBtn text-white rpsCopyBtn"
                              onClick={() => {
                                setIsView(false);
                                getCopyTaxInvoiceData(previewTaxInvoiceData.id);
                              }}
                            >
                              Copy
                            </Link>
                          </div>
                        ) : (
                          ""
                        )}

                        {jpegCheck && (
                          <div>
                            <Link
                              to="#"
                              onClick={() => {
                                exportComponentAsJPEG(container);
                              }}
                              className="salesCopyBtn text-white rpsCopyBtn"
                            >
                              JPEG
                            </Link>
                          </div>
                        )}
                        {pdfCheck && (
                          <div>
                            <Link
                              to="#"
                              onClick={exportPDFWithComponent}
                              className="salesCopyBtn text-white rpsCopyBtn"
                            >
                              PDF
                            </Link>
                          </div>
                        )}
                      </div>
                    </div>
                    <PDFExport
                      ref={pdfExportComponent}
                      paperSize="auto"
                      margin={40}
                      fileName={`Report for ${new Date().getFullYear()}`}
                      author="KendoReact Team"
                    >
                      {previewLoader ? (
                        <div style={{ margin: "50%" }}>
                          <BootstrapSpinner />
                        </div>
                      ) : (
                        <div ref={container} className="main-invoice-card">
                          <div className="invoice-inner-main">
                            <div className="text-invoice-main">
                              <div className="text-invoice-inner">
                                <div className="left">
                                  <div className="text-invoice-heading">
                                    {/* <label htmlFor="">Tax Invoice</label> */}
                                  </div>
                                  <div className="invoice-date-number">
                                    <label htmlFor="">
                                      {previewTaxInvoiceData.invoiceNo}
                                    </label>
                                    <label htmlFor="">
                                      Date:{" "}
                                      <span>
                                        {displayDateFormat(
                                          appSettings.dateFormat,
                                          previewTaxInvoiceData.invoiceDate
                                        )}
                                      </span>
                                    </label>
                                    <label htmlFor="">
                                      Due Date:
                                      <span>
                                        {displayDateFormat(
                                          appSettings.dateFormat,
                                          previewTaxInvoiceData.dueDate
                                        )}
                                      </span>
                                    </label>
                                  </div>
                                </div>
                                {/* <div className="right">
                                <img src={Logo} alt="" />
                              </div> */}
                              </div>
                            </div>
                            <div className="name-details-main">
                              <div className="name-details-inner row">
                                <div className="col-lg-7 left p-0">
                                  <div className="name">
                                    <label htmlFor="">
                                      {previewTaxInvoiceData.compName}
                                    </label>
                                    <Link to="#">
                                      {/* <img src={ic_green_pen} alt="" /> */}
                                    </Link>
                                  </div>
                                  <div className="address">
                                    <div>
                                      <label htmlFor="" id="address">
                                        {previewTaxInvoiceData.compAddr}
                                      </label>
                                    </div>
                                    <div>
                                      <label htmlFor="" className="contact">
                                        Email Id:
                                        <span>
                                          {" "}
                                          {previewTaxInvoiceData.compEmail}
                                        </span>
                                      </label>
                                    </div>
                                    <div>
                                      <label htmlFor="" className="contact">
                                        Contact No:
                                        <span>
                                          {" "}
                                          {previewTaxInvoiceData.compContact}
                                        </span>
                                      </label>
                                    </div>
                                    {appSettings && appSettings.isGSTApplicable && (
                                      <div>
                                        <label htmlFor="" className="gst-no">
                                          GST No. :{" "}
                                          <span>
                                            {" "}
                                            {previewTaxInvoiceData.compGstNo}
                                          </span>
                                        </label>
                                      </div>)}
                                    <div>
                                      <label htmlFor="" className="pan-no">
                                        PAN No. :{" "}
                                        <span>
                                          {previewTaxInvoiceData.compPanNo}
                                        </span>
                                      </label>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-5 right p-0">
                                  <div className="place-heading">
                                    <label htmlFor="">Place of Supply:</label>
                                    <Link to="#">
                                      {/* <img src={ic_green_pen} alt="" /> */}
                                    </Link>
                                  </div>
                                  <div className="place">
                                    <label htmlFor="">
                                      {previewTaxInvoiceData.placeOfSupply}
                                    </label>
                                  </div>
                                  <div className="place-heading">
                                    <label htmlFor="">Mode of Payment:</label>
                                    <Link to="#">
                                      {/* <img src={ic_green_pen} alt="" /> */}
                                    </Link>
                                  </div>
                                  <div className="place">
                                    <label htmlFor="">
                                      {previewTaxInvoiceData.modeOfPay}
                                    </label>{" "}
                                    <br />
                                    {isChequePayment && ( // Display Cheque No only if the mode of payment is "Cheque"

                                      <label htmlFor="Cheque No">
                                        ChequeNo:{" "}
                                        <span>
                                          {previewTaxInvoiceData.chequeNo}
                                        </span>
                                      </label>
                                    )}


                                    <br />
                                    <label htmlFor="">
                                      {previewTaxInvoiceData.bankName}
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="name-details-main" id="info">
                              <div className="name-details-inner row">
                                <div className="col-lg-7 left p-0">
                                  <div className="name">
                                    <label htmlFor="" id="small-heading">
                                      Bill To,
                                    </label>
                                    <Link to="#">
                                      {/* <img src={ic_green_pen} alt="" /> */}
                                    </Link>{" "}
                                    <br />
                                  </div>
                                  <div className="address">
                                    <div>
                                      <label htmlFor="">
                                        {previewTaxInvoiceData.suppName}
                                      </label>
                                    </div>
                                    <div>
                                      <label htmlFor="" id="address">
                                        {previewTaxInvoiceData.suppAddr}
                                      </label>
                                    </div>
                                    <div>
                                      <label htmlFor="" className="contact">
                                        Email Id :
                                        <span>
                                          {" "}
                                          {previewTaxInvoiceData.suppEmail}
                                        </span>
                                      </label>
                                    </div>
                                    <div>
                                      <label htmlFor="" className="contact">
                                        Contact No:
                                        <span>
                                          {" "}
                                          {previewTaxInvoiceData.suppContact}
                                        </span>
                                      </label>
                                    </div>
                                    {appSettings && appSettings.isGSTApplicable && (
                                      <div>
                                        <label htmlFor="" className="gst-no">
                                          GST:{" "}
                                          <span>
                                            {previewTaxInvoiceData.suppGstNo}{" "}
                                          </span>
                                        </label>
                                      </div>)}
                                  </div>
                                </div>
                                {/* Ship to */}
                                {previewTaxInvoiceData.shipName ? (
                                  <div className="col-lg-5 right p-0">
                                    <div className="name">
                                      <label htmlFor="" id="small-heading">
                                        Ship To,{" "}
                                      </label>
                                      <br />
                                    </div>
                                    <div className="address">
                                      <div>
                                        <label htmlFor="">
                                          {previewTaxInvoiceData.shipName}
                                        </label>
                                      </div>
                                      <div>
                                        <label htmlFor="" id="address">
                                          {previewTaxInvoiceData.shipAddr}
                                        </label>
                                      </div>
                                      <div>
                                        <label htmlFor="" className="contact">
                                          Contact No:
                                          <span>
                                            {" "}
                                            {previewTaxInvoiceData.shipContact}
                                          </span>
                                        </label>
                                      </div>
                                      {appSettings && appSettings.isGSTApplicable && (
                                        <div>
                                          <label htmlFor="" className="gst-no">
                                            GST:{" "}
                                            <span>
                                              {previewTaxInvoiceData.shipGstNo}{" "}
                                            </span>
                                          </label>
                                        </div>)}
                                    </div>
                                  </div>
                                ) : null}
                              </div>
                            </div>
                            <div
                              className="detail-table-main"
                              id="modal-in-tab"
                            >
                              <table>
                                <thead>
                                  <tr className="heading-row">
                                    <td>#</td>
                                    <td>Product Name/Service Name</td>
                                    <td>HSN/SAC</td>
                                    <td>Quantity</td>
                                    <td>Rate</td>
                                    <td>Unit</td>
                                    <td>Disc. <span>{discountVal.discType === "Amount" ? `(₹)` : `(%)`}</span></td>
                                    <td>Amount</td>
                                    {appSettings && appSettings.isGSTApplicable && (
                                      isStateSame) ? (
                                      <>
                                        <td colSpan="2">CGST</td>
                                        <td colSpan="2">SGST</td>
                                      </>
                                    ) : (
                                      <>
                                        {appSettings && appSettings.isGSTApplicable && (
                                          <td colSpan="2">IGST</td>)}
                                      </>
                                    )}
                                  </tr>
                                </thead>
                                <tbody>
                                  {previewTaxInvoiceData.purchInvDetails
                                    ?.length > 0 &&
                                    previewTaxInvoiceData.purchInvDetails.map(
                                      (invDetails, index) => {
                                        let unit =
                                          units &&
                                          units.filter((item) => {
                                            return (
                                              item.id === invDetails.unitId
                                            );
                                          })[0]?.unit;
                                        return (
                                          <tr key={invDetails.id}>
                                            <td>{1 + index}</td>
                                            <td>{invDetails.productName}</td>
                                            <td>{invDetails.hsnCode}</td>
                                            <td>{invDetails.qty}</td>
                                            <td>{invDetails.rate}</td>
                                            <td>{invDetails.unit}</td>
                                            <td>
                                              {invDetails.discPer}{" "}
                                              {appSettings?.discType ===
                                                "Amount"
                                                ? ""
                                                : "%"}
                                            </td>
                                            <td>{invDetails.discAmount}</td>
                                            {appSettings && appSettings.isGSTApplicable && (
                                              isStateSame) ? (
                                              <>
                                                <td>{invDetails.cgst}%</td>
                                                <td>{invDetails.cgstAmount}</td>
                                                <td>{invDetails.sgst}%</td>
                                                <td>{invDetails.sgstAmount}</td>
                                              </>
                                            ) : (
                                              <>
                                                {appSettings && appSettings.isGSTApplicable && (
                                                  <td>{invDetails.igst}%</td>)}

                                                {appSettings && appSettings.isGSTApplicable && (
                                                  <td>Rs. {invDetails.igstAmount}</td>)}

                                              </>
                                            )}
                                          </tr>
                                        );
                                      }
                                    )}
                                </tbody>
                              </table>
                            </div>

                            <div className="sub-total-section">
                              <div className="bank-details">
                                {previewTaxInvoiceData?.bankDetails && (
                                  <label htmlFor="">Bank Details :</label>
                                )}
                                {previewTaxInvoiceData?.bankDetails &&
                                  previewTaxInvoiceData?.bankDetails
                                    .split("\r\n")
                                    .map((str, i) => {
                                      return (
                                        <div
                                          key={i + "bankDetails"}
                                          className="bank-sub"
                                        >
                                          <label htmlFor="">{str && str}</label>
                                        </div>
                                      );
                                    })}
                              </div>
                              <div className="right-section">
                                <div className="left">
                                  <div className="text-sub">
                                    <label htmlFor="">Sub Total</label>
                                  </div>
                                  {appSettings && appSettings.isGSTApplicable && (
                                    isStateSame) ? (
                                    <>
                                      <div className="text-sub">
                                        <label htmlFor="">CGST</label>
                                      </div>
                                      <div className="text-sub">
                                        <label htmlFor="">SGST</label>
                                      </div>
                                    </>
                                  ) : (
                                    <>
                                      {appSettings && appSettings.isGSTApplicable && (
                                        <div className="text-sub">
                                          <label htmlFor="">IGST</label>
                                        </div>)}
                                    </>
                                  )}
                                  {appSettings && appSettings.isRoundOff && (
                                    <div className="text-sub">
                                      <label htmlFor="">Round off</label>
                                    </div>
                                  )}
                                </div>
                                <div className="right">
                                  <div className="sub-total">
                                    <label htmlFor="">
                                      Rs. {previewTaxInvoiceData.subTotal}
                                    </label>
                                  </div>
                                  {isStateSame ? (
                                    <>
                                      <div className="sub-total">
                                        <label htmlFor="">
                                          Rs.{" "}
                                          {previewTaxInvoiceData.cgstAmount?.toFixed(
                                            2
                                          )}
                                        </label>
                                      </div>
                                      <div className="sub-total">
                                        <label htmlFor="">
                                          Rs.{" "}
                                          {previewTaxInvoiceData.sgstAmount?.toFixed(
                                            2
                                          )}
                                        </label>
                                      </div>
                                    </>
                                  ) : (
                                    <>
                                      {appSettings && appSettings.isGSTApplicable && (
                                        <div className="sub-total">
                                          <label htmlFor="">
                                            Rs.{" "}
                                            {previewTaxInvoiceData.igstAmount?.toFixed(
                                              2
                                            )}
                                          </label>
                                        </div>)}
                                    </>
                                  )}
                                  {appSettings && appSettings.isRoundOff && (
                                    <div className="sub-total">
                                      <label htmlFor="">
                                        Rs.{" "}
                                        {previewTaxInvoiceData.roundOff?.toFixed(
                                          2
                                        ) || "0.00"}
                                      </label>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                            <div className="mainsub-total"></div>
                            <div className="total-amt-main">
                              <div
                                className="total-amount-section"
                                id="sub-total-section"
                              >
                                <div className="left">
                                  <div className="text-sub">
                                    <label htmlFor="">Total Amount</label>
                                  </div>
                                </div>
                                <div className="right">
                                  <div className="sub-total">
                                    <label htmlFor="">
                                      Rs.{" "}
                                      {commaNumber(
                                        Math.round(
                                          previewTaxInvoiceData.totalAmount
                                        )?.toFixed(2)
                                      )}
                                    </label>
                                  </div>
                                </div>
                              </div>
                              <div className="in-word">
                                <label htmlFor="">{amountInWords}</label>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </PDFExport>
                  </Modal.Body>
                </Modal>
                {/* =================== PREVIEW MODAL END ======================== */}

                {/* Print Modal, PrintModal */}
                {/* =================== PRINT MODAL START ======================== */}
                <Modal
                  className="sales-home-modal purchase-view-modal"
                  id="print-modal-style"
                  size="lg"
                  show={printModal}
                  onHide={() => setPrintModal(false)}
                  aria-labelledby="example-modal-sizes-title-lg"
                >
                  <Modal.Body>
                    <div className="btnCloseRper">
                      <div>
                        <Link
                          to="#"
                          className="text-white"
                          onClick={() => setIsView(false)}
                        >
                          <img
                            src={Axe}
                            alt=""
                            className="closeBtn"
                            onClick={() => setPrintModal(false)}
                          />
                        </Link>
                      </div>
                      <div>
                        <Link
                          to="#"
                          onClick={() => {
                            handlePrint();
                            setPrintModal(false);
                          }}
                          className="salesCopyBtn bluebg text-white rpsCopyBtn"
                          style={{ backgroundColor: "#53b7e8" }}
                        >
                          Print
                        </Link>
                      </div>
                    </div>

                    <div ref={container}>
                      {typeOfPrint.map((type, index) => {
                        return (
                          <div
                            key={"type" + index}
                            className="main-invoice-card  page-break"
                          >
                            <style>{getPageMargins()}</style>
                            <div
                              className="print-copy-type text-center "
                              style={{
                                marginTop: "-10px",
                                fontSize: "10px",
                              }}
                            >
                              Original for Buyer
                            </div>

                            <div
                              className="invoice-inner-main "
                              style={{
                                border: "0.765311px solid #111111",
                              }}
                            >
                              <div
                                className="text-invoice-main"
                                style={{
                                  borderBottom: "0.765311px solid #111111 ",
                                }}
                              >
                                <div className="text-invoice-inner coninversereponsive">
                                  <table style={{ width: "100%" }}>
                                    <tr>
                                      <td style={{ width: "100%" }}>
                                        <div className="left">
                                          <table>
                                            <tr>
                                              <td>
                                                <div className="text-invoice-heading">
                                                  <label htmlFor="">
                                                    Tax Invoice
                                                  </label>
                                                </div>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>
                                                <div className="invoice-date-number">
                                                  <table>
                                                    <tr>
                                                      <td>
                                                        <label htmlFor="">
                                                          {
                                                            previewTaxInvoiceData?.invoiceNo
                                                          }
                                                        </label>
                                                      </td>
                                                      <td>
                                                        <label htmlFor="">
                                                          Date: &nbsp;
                                                          <span>
                                                            {displayDateFormat(
                                                              appSettings.dateFormat,
                                                              previewTaxInvoiceData.invoiceDate
                                                            )}
                                                          </span>
                                                        </label>
                                                      </td>
                                                      <td>
                                                        <label htmlFor="">
                                                          Due Date: &nbsp;
                                                          <span>
                                                            {displayDateFormat(
                                                              appSettings.dateFormat,
                                                              previewTaxInvoiceData.dueDate
                                                            )}
                                                          </span>
                                                        </label>
                                                      </td>
                                                    </tr>
                                                  </table>
                                                </div>
                                              </td>
                                            </tr>
                                          </table>
                                        </div>
                                      </td>
                                      <td>
                                        {/* <div className="right">
                                          <img src={Logo} alt="" />
                                        </div> */}
                                      </td>
                                    </tr>
                                  </table>
                                </div>
                              </div>
                              <div
                                className="name-details-main"
                                style={{
                                  borderBottom: "0.765311px solid #111111 ",
                                }}
                              >
                                <div
                                  className="name-details-inner "
                                  style={{ margin: "0" }}
                                >
                                  <div className="print-table-outer">
                                    <table style={{ width: "100%" }}>
                                      <tr>
                                        <td
                                          style={{ width: "58%" }}
                                          valign="top"
                                        >
                                          <div className=" left p-0">
                                            <div className="name">
                                              <label htmlFor="">
                                                {previewTaxInvoiceData.suppName}
                                              </label>
                                            </div>
                                            <div className="address">
                                              <div>
                                                <label htmlFor="" id="address">
                                                  {
                                                    previewTaxInvoiceData.suppAddr
                                                  }
                                                </label>
                                              </div>
                                              <div>
                                                <label
                                                  htmlFor=""
                                                  className="contact"
                                                  style={{ fontSize: "11px" }}
                                                >
                                                  Email Id :
                                                  <span>
                                                    {" "}
                                                    {
                                                      previewTaxInvoiceData.compEmail
                                                    }
                                                  </span>
                                                </label>
                                              </div>
                                              <div>
                                                <label
                                                  htmlFor=""
                                                  className="contact"
                                                  style={{ fontSize: "11px" }}
                                                >
                                                  Contact No:
                                                  <span>
                                                    {" "}
                                                    {
                                                      previewTaxInvoiceData.compContact
                                                    }
                                                  </span>
                                                </label>
                                              </div>
                                              {appSettings && appSettings.isGSTApplicable && (
                                                <div>
                                                  <label
                                                    htmlFor=""
                                                    className="gst-no"
                                                  >
                                                    GST No. :
                                                    <span>
                                                      {" "}
                                                      {
                                                        previewTaxInvoiceData.compGstNo
                                                      }
                                                    </span>
                                                  </label>
                                                </div>)}
                                              <div>
                                                <label
                                                  htmlFor=""
                                                  className="pan-no"
                                                >
                                                  PAN No. :{" "}
                                                  <span>
                                                    {
                                                      previewTaxInvoiceData.compPanNo
                                                    }
                                                  </span>
                                                </label>
                                              </div>
                                            </div>
                                          </div>
                                        </td>
                                        <td>
                                          <div
                                            className=" right p-0"
                                            style={{ margin: "-12px 0 0 0" }}
                                          >
                                            <div className="place-heading">
                                              <label htmlFor="">
                                                Place of Supply:
                                              </label>
                                            </div>
                                            <div className="place">
                                              <label htmlFor="">
                                                {
                                                  previewTaxInvoiceData.placeOfSupply
                                                }
                                              </label>
                                            </div>
                                            <div className="place-heading">
                                              <label htmlFor="">
                                                Mode of Payment:
                                              </label>
                                            </div>
                                            <div className="place">
                                              <div>
                                                {/* <label htmlFor="">
                                                  Cash/Cheque.
                                                </label> */}
                                                <span>
                                                  {
                                                    previewTaxInvoiceData.modeOfPay
                                                  }
                                                </span>
                                              </div>
                                              <div>
                                                {isChequePayment && ( // Display Cheque No only if the mode of payment is "Cheque"

                                                  <label htmlFor="Cheque No">
                                                    ChequeNo. :{" "}

                                                    <span>
                                                      {
                                                        previewTaxInvoiceData.chequeNo
                                                      }
                                                    </span>
                                                  </label>
                                                )}
                                              </div>

                                              <div>
                                                <label htmlFor="">
                                                  {
                                                    previewTaxInvoiceData.bankName
                                                  }
                                                </label>
                                              </div>
                                            </div>
                                          </div>
                                        </td>
                                      </tr>
                                    </table>
                                  </div>
                                </div>
                              </div>
                              <div className="name-details-main" id="info">
                                <div className="name-details-inner  ">
                                  <div className="print-table-outer">
                                    <table
                                      className=""
                                      style={{ width: "100%" }}
                                    >
                                      <tr>
                                        <td style={{ width: "58%" }}>
                                          <div className=" left p-0">
                                            <div className="name">
                                              <label
                                                htmlFor=""
                                                id="small-heading"
                                              >
                                                Bill To,
                                              </label>

                                              <br />
                                            </div>
                                            <div className="address">
                                              <div>
                                                <label htmlFor="">
                                                  {
                                                    previewTaxInvoiceData.suppName
                                                  }
                                                </label>
                                              </div>
                                              <div>
                                                <label htmlFor="" id="address">
                                                  {
                                                    previewTaxInvoiceData.suppAddr
                                                  }
                                                </label>
                                              </div>
                                              <div>
                                                <label
                                                  htmlFor=""
                                                  className="contact"
                                                >
                                                  Email Id :
                                                  <span>
                                                    {" "}
                                                    {
                                                      previewTaxInvoiceData.suppEmail
                                                    }
                                                  </span>
                                                </label>
                                              </div>
                                              <div>
                                                <label
                                                  htmlFor=""
                                                  className="contact"
                                                >
                                                  Contact No:
                                                  <span>
                                                    {" "}
                                                    {
                                                      previewTaxInvoiceData.suppContact
                                                    }
                                                  </span>
                                                </label>
                                              </div>
                                              {appSettings && appSettings.isGSTApplicable && (
                                                <div>
                                                  <label
                                                    htmlFor=""
                                                    className="gst-no"
                                                  >
                                                    GST:{" "}
                                                    <span>
                                                      {
                                                        previewTaxInvoiceData.suppGstNo
                                                      }{" "}
                                                    </span>
                                                  </label>
                                                </div>)}
                                            </div>
                                          </div>
                                        </td>
                                        <td>
                                          {previewTaxInvoiceData?.shipName ? (
                                            <div className=" right p-0">
                                              <div className="name">
                                                <label
                                                  htmlFor=""
                                                  id="small-heading"
                                                >
                                                  Ship To,{" "}
                                                </label>

                                                <br />
                                              </div>
                                              <div className="address">
                                                <div>
                                                  <label htmlFor="">
                                                    {
                                                      previewTaxInvoiceData.shipName
                                                    }
                                                  </label>
                                                </div>
                                                <div>
                                                  <label
                                                    htmlFor=""
                                                    id="address"
                                                  >
                                                    {
                                                      previewTaxInvoiceData.shipAddr
                                                    }
                                                  </label>
                                                </div>
                                                <div>
                                                  <label
                                                    htmlFor=""
                                                    className="contact"
                                                  >
                                                    Contact No:
                                                    <span>
                                                      {" "}
                                                      {
                                                        previewTaxInvoiceData.shipContact
                                                      }
                                                    </span>
                                                  </label>
                                                </div>
                                                {appSettings && appSettings.isGSTApplicable && (
                                                  <div>
                                                    <label
                                                      htmlFor=""
                                                      className="gst-no"
                                                    >
                                                      GST:{" "}
                                                      <span>
                                                        {
                                                          previewTaxInvoiceData.shipGstNo
                                                        }{" "}
                                                      </span>
                                                    </label>
                                                  </div>)}
                                              </div>
                                            </div>
                                          ) : null}
                                        </td>
                                      </tr>
                                    </table>
                                  </div>
                                </div>
                              </div>

                              <div
                                className="detail-table-main"
                                id="modal-in-tab"
                                style={{ marginTop: "-4px" }}
                              >
                                <table
                                  style={{
                                    borderTop: "0.765311px solid #111111",
                                    borderBottom: "0.765311px solid #111111",
                                    width: "100%",
                                  }}
                                >
                                  <thead>
                                    <tr className="heading-row">
                                      <td style={{ paddingLeft: "10px" }}>#</td>
                                      <td>Product Name/Service Name</td>
                                      <td>HSN/SAC</td>
                                      <td>Quantity</td>
                                      <td>Rate</td>
                                      <td>Unit</td>
                                      <td>Discount</td>
                                      <td>Amount</td>
                                      {appSettings && appSettings.isGSTApplicable && (
                                        isStateSame) ? (
                                        <>
                                          <td colSpan="2">CGST</td>
                                          <td colSpan="2">SGST</td>
                                        </>
                                      ) : (
                                        <>
                                          {appSettings && appSettings.isGSTApplicable && (
                                            <td colSpan="2">IGST</td>)}
                                        </>
                                      )}
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {previewTaxInvoiceData.purchInvDetails &&
                                      previewTaxInvoiceData.purchInvDetails
                                        .length > 0 &&
                                      previewTaxInvoiceData.purchInvDetails.map(
                                        (invDetails, index) => {
                                          let unit =
                                            units &&
                                            units.filter((item) => {
                                              return (
                                                item.id === invDetails.unitId
                                              );
                                            })[0]?.unit;
                                          return (
                                            <tr key={invDetails.id}>
                                              <td
                                                style={{
                                                  paddingTop: "2px",
                                                  paddingBottom: "2px",
                                                  paddingLeft: "10px",
                                                }}
                                              >
                                                {index + 1}
                                              </td>
                                              <td style={{ padding: "2px 4px" }}>
                                                {invDetails.productName}
                                              </td>
                                              <td style={{ padding: "2px 4px" }}>
                                                {invDetails.hsnCode}
                                              </td>
                                              <td style={{ padding: "2px 4px" }}>
                                                {invDetails.qty}
                                              </td>
                                              <td style={{ padding: "2px 4px" }}>
                                                {invDetails.rate}
                                              </td>
                                              <td style={{ padding: "2px 4px" }}>
                                                {invDetails.unit}
                                              </td>
                                              <td style={{ padding: "2px 4px" }}>
                                                {invDetails.discPer}{" "}
                                                {appSettings?.discType ===
                                                  "Amount"
                                                  ? ""
                                                  : "%"}
                                              </td>
                                              <td style={{ padding: "2px 4px" }}>
                                                {invDetails.discAmount}
                                              </td>
                                              {appSettings && appSettings.isGSTApplicable && (
                                                isStateSame) ? (
                                                <>
                                                  <td
                                                    style={{ padding: "2px 4px" }}
                                                  >
                                                    {invDetails.cgst}%
                                                  </td>
                                                  <td
                                                    style={{ padding: "2px 4px" }}
                                                  >
                                                    {invDetails.cgstAmount}
                                                  </td>
                                                  <td
                                                    style={{ padding: "2px 4px" }}
                                                  >
                                                    {invDetails.sgst}%
                                                  </td>
                                                  <td
                                                    style={{ padding: "2px 4px" }}
                                                  >
                                                    {invDetails.sgstAmount}
                                                  </td>
                                                </>
                                              ) : (
                                                <>
                                                  {appSettings && appSettings.isGSTApplicable && (
                                                    <td
                                                      style={{ padding: "2px 4px" }}
                                                    >
                                                      {invDetails.igst}%
                                                    </td>)}
                                                  {appSettings && appSettings.isGSTApplicable && (
                                                    <td
                                                      style={{ padding: "2px 4px" }}
                                                    >
                                                      {invDetails.igstAmount}
                                                    </td>)}
                                                </>
                                              )}
                                            </tr>
                                          );
                                        }
                                      )}
                                  </tbody>
                                </table>
                              </div>

                              <div
                                className="sub-total-section"
                                style={{ marginTop: "-20px  " }}
                              >
                                <div className="bank-details">
                                  {previewTaxInvoiceData?.bankDetails && (
                                    <label htmlFor="">Bank Details :</label>
                                  )}
                                  {previewTaxInvoiceData?.bankDetails &&
                                    previewTaxInvoiceData?.bankDetails
                                      .split("\r\n")
                                      .map((str, i) => {
                                        return (
                                          <div
                                            key={i + "bankDetails"}
                                            className="bank-sub"
                                          >
                                            <label htmlFor="">
                                              {str && str}
                                            </label>
                                          </div>
                                        );
                                      })}
                                </div>
                                <div className="right-section">
                                  <div className="left">
                                    <div className="text-sub">
                                      <label htmlFor="">Sub Total</label>
                                    </div>
                                    {appSettings && appSettings.isGSTApplicable && (
                                      isStateSame) ? (
                                      <>
                                        <div className="text-sub">
                                          <label htmlFor="">CGST</label>
                                        </div>
                                        <div className="text-sub">
                                          <label htmlFor="">SGST</label>
                                        </div>
                                      </>
                                    ) : (
                                      <>
                                        {appSettings && appSettings.isGSTApplicable && (
                                          <div className="text-sub">
                                            <label htmlFor="">IGST</label>
                                          </div>)}
                                      </>
                                    )}
                                    {appSettings && appSettings.isRoundOff && (
                                      <div className="text-sub">
                                        <label htmlFor="">Round off</label>
                                      </div>
                                    )}
                                  </div>
                                  <div className="right">
                                    <div className="sub-total">
                                      <label htmlFor="">
                                        ₹ {previewTaxInvoiceData.subTotal}
                                      </label>
                                    </div>
                                    {appSettings && appSettings.isGSTApplicable && (
                                      isStateSame) ? (
                                      <>
                                        <div className="sub-total">
                                          <label htmlFor="">
                                            ₹ {previewTaxInvoiceData.cgstAmount}
                                          </label>
                                        </div>
                                        <div className="sub-total">
                                          <label htmlFor="">
                                            ₹ {previewTaxInvoiceData.sgstAmount}
                                          </label>
                                        </div>
                                      </>
                                    ) : (
                                      <>
                                        {appSettings && appSettings.isGSTApplicable && (
                                          <div className="sub-total">
                                            <label htmlFor="">
                                              ₹ {previewTaxInvoiceData.igstAmount}
                                            </label>
                                          </div>)}
                                      </>
                                    )}
                                    {appSettings && appSettings.isRoundOff && (
                                      <div className="sub-total">
                                        <label htmlFor="">
                                          Rs.{" "}
                                          {previewTaxInvoiceData.roundOff.toFixed(
                                            2
                                          ) || "0.00"}
                                        </label>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                              <div
                                className="mainsub-total"
                                style={{
                                  borderBottom:
                                    "0.765311px solid rgba(35, 33, 34, 0.5) ",
                                }}
                              ></div>
                              <div className="total-amt-main">
                                <div
                                  className="total-amount-section"
                                  id="sub-total-section"
                                >
                                  <div className="left">
                                    <div className="text-sub">
                                      <label htmlFor="">Total Amount</label>
                                    </div>
                                  </div>
                                  <div className="right">
                                    <div className="sub-total">
                                      <label htmlFor="">
                                        Rs.{" "}
                                        {commaNumber(
                                          Math.round(
                                            previewTaxInvoiceData.totalAmount
                                          ).toFixed(2)
                                        )}
                                      </label>
                                    </div>
                                  </div>
                                </div>
                                <div className="in-word">
                                  <label htmlFor="">{amountInWords}</label>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </Modal.Body>
                </Modal>
                {/* =================== PRINT MODAL END ============================ */}
              </div>

              {/* ======== RIGHT SECTION ============ */}
              <div
                className="col-lg-4 right-section my-2"
                style={{ display: hideBothSide?.displayBlock }}
              >
                <div className="cx-search-wrapper">
                  {Dark === "lightMode" ? (
                    <>
                      <img src={ic_search} alt="" className="search-img" />
                      <img src={ic_bars_dot} alt="" className="bars-img" />
                    </>
                  ) : (
                    <>
                      <img src={ic_search_dark} alt="" className="search-img" />
                      <img src={ic_bars_dot_dark} alt="" className="bars-img" />
                    </>
                  )}
                  <input
                    type="text"
                    className="form-control"
                    placeholder={appSettings.isGSTApplicable ? "Enter GST No to Search" : "Enter customer name to search"}
                    value={upperCaseGstNumber}
                    onChange={(e) => {
                      setUpperCaseGstNumber(e.target.value.toUpperCase());
                      handleInvoiceSearch(e);
                    }}
                  />
                </div>
                {loading ? (
                  <Loader />
                ) : (
                  <div className="card-right-main">
                    <Tab.Container id="left-tabs-example" defaultActiveKey="">
                      <Nav variant="pills" className="flex-column">
                        {invoiceListData && invoiceListData.length > 0 ? (
                          <React.Fragment>
                            {invoiceListData.map((item, index) => {
                              return (
                                <Nav.Item
                                  onClick={() => {
                                    // setSelectedInvoiceId(item.invoiceId);
                                    getTaxInvoiceData(item.invoiceId);
                                    setIsView(true);
                                    setHideCopy(false);
                                    setJpegCheck(false);
                                    setpdfCheck(false);
                                    setPrintButton(true);
                                  }}
                                  key={item.invoiceId}
                                >
                                  <Nav.Link eventKey={"item" + index}>
                                    <div className=" ">
                                      <div className="inner">
                                        <div className="left">
                                          <div className="cus-name">
                                            <label htmlFor="">
                                              {item.supplierName}
                                            </label>
                                          </div>
                                          <div className="inn-no-date">
                                            <label htmlFor="" className="inn">
                                              {item.invoiceNo}
                                            </label>
                                            <span className="line "></span>
                                            <label htmlFor="" className="date">
                                              {displayDateFormat(
                                                appSettings.dateFormat,
                                                item.invoiceDate
                                              )}
                                            </label>
                                          </div>
                                        </div>
                                        <div className="right">
                                          <div className="amt">
                                            <label htmlFor="">
                                              {commaNumber(item.invoiceAmount)}
                                            </label>
                                          </div>
                                          <div className="status">
                                            <label htmlFor="">
                                              {item.invoiceStatus}
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </Nav.Link>
                                </Nav.Item>
                              );
                            })}
                          </React.Fragment>
                        ) : (
                          // <p className="mt-5 m-auto text-danger">
                          //   No Records Found{" "}
                          // </p>
                          <p className="mt-5 m-auto txt-no-record">
                            No Records to Show{" "}
                          </p>
                        )}
                      </Nav>
                    </Tab.Container>
                  </div>
                )}
              </div>
            </div>
          </section>
        </div>
      </main>
    </>
  );
};
export default PurchaseServices;
